function zenInitSticky(){
 const sticky=document.querySelector('[data-zen-sticky]');
 const info=document.querySelector('product-info');
 if(!sticky||!info||sticky.dataset.initialized)return;
 sticky.dataset.initialized='true';
 const button=sticky.querySelector('button');
 const amount=sticky.querySelector('[data-zen-sticky-price]');
 let observed;
 const observer=new IntersectionObserver(()=>sync(),{threshold:0});
 function sync(){
   const main=info.querySelector('button[name="add"]');
   if(!main){sticky.hidden=true;return;}
   if(main!==observed){observer.disconnect();observer.observe(main);observed=main;}
   button.disabled=main.disabled;
   button.textContent=main.querySelector('span')?.textContent.trim()||main.textContent.trim();
   const sale=info.querySelector('.price')?.classList.contains('price--on-sale');
   amount.textContent=info.querySelector(sale?'.price-item--sale':'.price__regular .price-item--regular')?.textContent.trim()||'';
   sticky.hidden=main.getBoundingClientRect().bottom>=0;
 }
 button.addEventListener('click',()=>{const main=info.querySelector('button[name="add"]');if(main&&!main.disabled&&main.form)main.form.requestSubmit(main);});
 new MutationObserver(sync).observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','class']});
 let frame;
 window.addEventListener('scroll',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=undefined;sync();});},{passive:true});
 window.addEventListener('resize',sync);
 sync();
}
document.addEventListener('DOMContentLoaded',zenInitSticky);
document.addEventListener('shopify:section:load',zenInitSticky);